import React from "react";
import Box from "@mui/material/Box/Box";
import GenieText from "../genie-text/GenieText";
import { theme } from "../../special/genie-theme/genie-theme";

interface GenieEmptyProps {
  children: React.ReactNode;
}

function GenieEmpty({ children }: GenieEmptyProps) {
  return (
    <Box
      mt={8}
      p={8}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      border={"1px dashed"}
      borderColor={"grey.300"}
      borderRadius={theme.shape.borderRadius}
    >
      <GenieText fontSize={"small"}>{children}</GenieText>
    </Box>
  );
}

export default GenieEmpty;
